<template>
  <div class="d-flex flex-row h-100">
    <div class="d-flex flex-column col-3 h-100" style="width: 25rem;">
      <b-overlay :show="editing" :opacity="0.95" blur="5px" variant="transparent" class="d-flex flex-column w-100 h-100">
        <template #overlay>
          <div class="text-center">
            <i class="far fa-edit fa-3x"></i>
          </div>
        </template>

        <b-form-input type="search"
                  :placeholder="$lang.Common.Buttons.Search + '...'"
                  class="my-1"
                  @input="onSearchFieldChanged"/>
        <ag-grid-vue
          class="ag-theme-alpine flex-grow-1"
          :getLocaleText="localeTextFunc"
          :enableRangeSelection="true"
          :gridOptions="contractGridOptions"
          :columnTypes="columnTypes"
          :columnDefs="contractColumnDefs"
          :rowData="contracts"
          :excelStyles="excelStyles"
          rowSelection="single"
          :getRowId="params => params.data.contratoID"
          :suppressContextMenu="true"
          :suppressCopyRowsToClipboard="true"
          :suppressCutToClipboard="true"
          :suppressMultiRangeSelection="true"
          :suppressHorizontalScroll="true"
          :rowHeight="25"
          @cellDoubleClicked="onSelect"
          >
        </ag-grid-vue>
      </b-overlay>
    </div>
    <b-card class="d-flex m-0 w-100 h-100" body-class="d-flex flex-column h-100" v-if="editing">
      <template #header>
        <i class="far fa-edit"></i>
        <strong>{{ $lang.PCI.ContractMaintenance.Title }}</strong>
        <div class="card-actions">
          <b-link href="#" v-b-tooltip.hover :title="$lang.Common.Buttons.Save" @click="onSave">
            <i class="fas fa-check" style="font-size:1rem;color:var(--success);"></i>
          </b-link>
          <b-link href="#" v-if="editing" v-b-tooltip.hover :title="$lang.Common.Close" @click="onClose">
            <i class="fas fa-times" style="font-size:1rem;color:var(--success);"></i>
          </b-link>
        </div>
      </template>

      <b-form-group :label="$lang.PCI.ContractMaintenance.LabelContract" class="my-1 mb-3">
        <b-form-input v-model="selectedContract.descricao" disabled></b-form-input>
      </b-form-group>
      <div class="d-flex flex-row">
        <span class="mr-1" style="width: calc((100% - 24px) / 2);">{{ $lang.PCI.ContractMaintenance.LabelClassification }}</span>
        <span class="ml-1" style="width: calc((100% - 24px) / 2);">{{ $lang.PCI.ContractMaintenance.LabelCopType }}</span>
      </div>
      <div v-for="(item, index) of classifs" :key="item.id" class="d-flex flex-row align-items-center mt-1">
        <div class="d-flex position-relative d-inline-block mr-1" style="width: calc((100% - 24px) / 2);">
          <div class="d-flex form-control align-items-center" style="background-color: #f7f7f7;">
            <div class="flex-grow-1">{{ `(${item.obraClassificacao.codigo}) ${item.obraClassificacao.nome}` }}</div>
            <spam  class="badge badge-primary" style="height: 16px;" v-b-tooltip.hover title="Quantidade de obras associadas" placement="right">
              {{ (item.obras && item.obras.length) || 0 }}
            </spam>
          </div>
        </div>
        <b-form-input v-model="item.copModelo.nome" disabled class="ml-1" style="width: calc((100% - 24px) / 2);"></b-form-input>
        <i v-if="(item.obras && item.obras.length) === 0" class="fas fa-trash p-1 pointer" style="width: 24px; font-size: 1rem;" @click="onDelete(index)" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonDelete"></i>
      </div>
      <div class="d-flex flex-row align-items-center mt-3">
        <v-select ref="selClassif" class="mr-1" style="width: calc((100% - 24px) / 2);" v-model="newClassif.obraClassificacaoId" :options="workClassifs" :getOptionLabel="param => `(${param.codigo}) ${param.nome}`" :reduce="param => param.id" @input="onAdd"></v-select>
        <v-select ref="selType" class="ml-1" style="width: calc((100% - 24px) / 2);" v-model="newClassif.copModeloId" :options="copTypes" :getOptionLabel="param => `(${param.codigo}) ${param.nome}`" :reduce="param => param.id" @input="onAdd"></v-select>
        <!-- <i class="fas fa-plus p-1 pointer" style="width:24px; font-size: 1rem;" @click="onAdd" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonNew"></i> -->
      </div>
    </b-card>
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools'
import ContractsRepository from '@/shared/http/repositories/pci/contract'
import { loading, toast } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'
import { AgGridVue } from 'ag-grid-vue'
import gridMixin from '../mixins/gridMixin'
import COPTypeRepository from '@/shared/http/repositories/pci/coptype'
import WkClassifRepository from '@/shared/http/repositories/pci/workclassification'
import { v4 } from 'uuid'

export default {
  name: 'ContractMaintenance',
  components: {AgGridVue},
  mixins: [CompanyMixin, gridMixin],
  mounted () {
    Tools.MinimizedSidebar()
    this.onLoad()
  },
  data () {
    return {
      contracts: [],
      classifs: [],
      workClassifsOrig: [],
      workClassifs: [],
      copTypesOrig: [],
      copTypes: [],
      selectedContract: {},
      newClassif: {},
      editing: false,
      contractGridOptions: {
        headerHeight: 40,
        defaultColDef: {
          menuTabs: [],
          sortable: true,
          lockVisible: true
        }
      },
      contractColumnDefs: [
        {
          headerName: this.$lang.PCI.ContractMaintenance.LabelContract,
          field: 'descricao',
          flex: 1
        }
      ]
    }
  },
  methods: {
    onLoad () {
      loading.push()
      ContractsRepository.GetAll(this.company.id)
        .then(response => {
          if (response.data.code > 0) {
            this.contracts = response.data.data
          } else throw new Error(response.data.message)
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())

      loading.push()
      COPTypeRepository.GetAll(this.company.id)
        .then(response => {
          if (response.data.code > 0) {
            this.copTypesOrig = response.data.data
          }
        })
        .finally(() => loading.close())

      loading.push()
      WkClassifRepository.GetAll(this.company.id)
        .then(response => {
          if (response.data.code > 0) {
            this.workClassifsOrig = response.data.data
          }
        })
        .finally(() => loading.close())
    },
    onSearchFieldChanged (value) {
      this.contractGridOptions.api.setQuickFilter(value)
    },
    onSelect (params) {
      loading.push()
      ContractsRepository.GetClassif({params: {contratoID: params.data.contratoID}})
        .then(response => {
          if (response.data.code > 0) {
            this.selectedContract = params.data
            this.classifs = response.data.data
            this.processOptions()
            this.editing = true
          } else throw new Error(response.data.messate)
        })
        .catch(err => {
          console.log(err)
          toast(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onAdd () {
      if (this.newClassif.copModeloId && this.newClassif.obraClassificacaoId) {
        this.newClassif.obraClassificacao = this.workClassifs.find(wc => wc.id === this.newClassif.obraClassificacaoId)
        this.newClassif.copModelo = this.copTypes.find(ct => ct.id === this.newClassif.copModeloId)
        this.newClassif.obras = []
        this.classifs.push(this.newClassif)
        this.processOptions()
      }
    },
    onDelete (index) {
      this.classifs.splice(index, 1)
      this.processOptions()
    },
    onSave () {
      loading.push()
      ContractsRepository.SaveClassif(this.selectedContract.contratoID, this.classifs)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onClose()
          } else throw new Error(response.data.messate)
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onClose () {
      this.editing = false
      this.selectedContract = {}
      this.newClassif = {}
    },
    processOptions () {
      this.workClassifs = this.workClassifsOrig.filter(wc => !this.classifs.some(dt => dt.obraClassificacaoId === wc.id))
      this.copTypes = this.copTypesOrig.filter(ct => !this.classifs.some(dt => dt.copModeloId === ct.id))
      this.$nextTick(() => {
        this.newClassif = {
          id: v4(),
          contratoID: this.selectedContract.contratoID
        }
      })
    }
  }
}
</script>

<style scoped>
.ag-theme-alpine {
  --ag-header-background-color: #008143;
}
.input-badge {
  position: absolute;
  top: 50%;
  right: 8px; /* distância da borda direita */
  transform: translateY(-50%);
  pointer-events: none; /* evita que o badge atrapalhe clique/foco */
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/contractmaintenance/contractmaintenance.vue